ArticlesController.$inject = ['$rootScope', 'ArticleService', '$stateParams', '$timeout', '$state']

export default function ArticlesController($rootScope, ArticleService, $stateParams, $timeout, $state) {
  var vm = this

  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      ArticleService.getArticles(profileId).then(res => vm.articles = res.data)
    }
  })

  vm.currentPage = $stateParams.page
  vm.pageSize = 24
  vm.maxSize = 5

  vm.setSortBy = function(property) {
    var copy = vm.articles
    vm.articles = null
    function compare(a, b) {
      let comparison = 0
      if (a[property] > b[property]) {
        comparison = vm.sortChanged ? -1 : 1
      } else if (a[property] < b[property]) {
        comparison = vm.sortChanged ? 1 : -1
      }
      return comparison
    }
    copy.sort(compare)
    vm.sortChanged = !vm.sortChanged
    $timeout(function() {
      vm.articles = copy
    }, 100)
  }
  vm.toggleManageCategories = function() {
    vm.manageCategories = !vm.manageCategories
  }
  vm.numberOfPages = function() {
    return parseInt(vm.articles.length / vm.pageSize)
  }
  vm.pageChanged = function(currentPage) {
    $state.go('.', { page: currentPage }, { notify: false })
  }
}